<template>
    <DCard padding>
        <DTable
            :items="billingCycles"
            :fields="[
                {key: 'billing_cycle', label: __('settings.lov_billing_cycles.table.billing_cycle')},
                {key: 'name_de', label: __('settings.lov_billing_cycles.table.name_de')},
                {key: 'name_en', label: __('settings.lov_billing_cycles.table.name_en')},
                {key: 'actions', label: '', sorter: false}
            ]"
        >
            <template #actions="{item}">
                <td>
                    <DButton
                        :id="`edit_billing_cycle_${item.id}`"
                        icon="pencil"
                        mini
                        @click="openEditModal(item)"
                    />
                    <DButton
                        :id="`delete_billing_cycle_${item.id}`"
                        :disabled="item.is_deletable"
                        color="danger"
                        icon="trash-can-outline"
                        mini
                        @click="openDeleteModal(item)"
                    />
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.lov_billing_cycles.add_billing_cycle')"
                @click="openCreateModal"
            />
        </DFabs>

        <DModal
            v-if="showDeleteModal"
            :show="showDeleteModal"
            is-confirm
            is-error
            :title="__('settings.lov_billing_cycles.modals.delete.title')"
            :message="__('settings.lov_billing_cycles.modals.delete.message')"
            @close="closeDeleteModal"
            @confirm="deleteBillingCycle"
        />
        <BillingCycleModal
            v-if="showCreateModal"
            :show="showCreateModal"
            :billing-cycle="selectedBillingCycle"
            :is-create="isCreate"
            @closeModal="closeCreateModal"
        />
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import LovLayout from '~@/Pages/Settings/Lov/LovLayout.vue'
import { ref } from 'vue'
import BillingCycleModal from '~@/Components/Settings/LovBillingCycles/BillingCycleModal.vue'

export default {
    components: [BillingCycleModal],
    layout: [App, LovLayout]
}
</script>

<script setup>

defineProps({
    billingCycles: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const selectedBillingCycle = ref(null)
const showCreateModal = ref(false)
const showDeleteModal = ref(false)
const isCreate = ref(true)

function openCreateModal () {
    selectedBillingCycle.value = null
    isCreate.value = true
    showCreateModal.value = true
}

function openEditModal (item) {
    selectedBillingCycle.value = item
    isCreate.value = false
    showCreateModal.value = true
}

function openDeleteModal (item) {
    selectedBillingCycle.value = item
    showDeleteModal.value = true
}

function closeDeleteModal () {
    selectedBillingCycle.value = null
    showDeleteModal.value = false
}

function closeCreateModal () {
    showCreateModal.value = null
}

function deleteBillingCycle () {
    showDeleteModal.value = false
    router.delete(route('settings.billing-cycles.destroy', { billing_cycle: selectedBillingCycle.value.billing_cycle }))
}

</script>

<style lang="scss" scoped>
.ul-class{
    margin: 0;
    padding-left: 15px;
}
</style>
